import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ETonalButtonClassNames } from '../../enums/ETagButtonColors';
import { EUserRoles } from '../../enums/EUserRoles';
import { PageRoutes } from '../../enums/enums';
import { getAppEnvironment, userHasRole } from '../../utils/utils';
import CLocalizedText from '../CLocalizedText';
import TagButton from '../TagButton';

const environmentColors = {
  LOCAL: ETonalButtonClassNames.TEAL_GREEN_1,
  DEV: ETonalButtonClassNames.TEAL_GREEN_1,
  STAGING: ETonalButtonClassNames.TEAL_PPT_1,
  PROD: ETonalButtonClassNames.TEAL_PPT_4
};

export default function PageFooter() {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();

  const isStaff = userHasRole(keycloak.tokenParsed, [[EUserRoles.STAFF]]);
  const environment = getAppEnvironment();

  return (
    <div>
      <div className={'p-4 text-xs w-full'}>
        <div className={'flex flex-wrap gap-4 gap-y-2 items-center justify-center md:justify-end'}>
          <button
            className={'group'}
            onClick={() => {
              navigate('/' + PageRoutes.TERMS_OF_USE_INDEX);
            }}
          >
            <span className={'text-teal-1 font-bold group-hover:text-teal-green-1'}>
              <CLocalizedText dictKey={'global.termsOfUse.footer.button'} />
            </span>
          </button>
          <Link to={'https://www.nexdos.de/impressum/'}>
            <CLocalizedText dictKey={'globalFooterImpressum'} />
          </Link>

          <Link to={'https://www.nexdos.de/privacy-policy/'}>
            <CLocalizedText dictKey={'globalFooterDatenschutzerklaerung'} />
          </Link>

          {isStaff ? (
            <div className={'flex items-center gap-2'}>
              <Link to={PageRoutes.CONTACT_OUTLET}>
                <CLocalizedText dictKey={'global.footer.portalFeedback'} />
              </Link>

              <TagButton color={environmentColors[environment]}>{environment}</TagButton>
            </div>
          ) : (
            <Link to={PageRoutes.CONTACT_OUTLET}>
              <CLocalizedText dictKey={'contact.title'} />
            </Link>
          )}

          <span>&copy; {new Date().getFullYear()} Nexdos GmbH</span>
        </div>
      </div>
    </div>
  );
}
